export default __webpack_public_path__ + "static/media/FurJaden1.0ed0c154.jpg";